export default function(api: GlobalFetch) {
  return async function(recipient: string, subject: string, body: string) {
    const requestBody = { body, recipient, subject }
    const response = await api.fetch('/api/v2/misc/sendmail', {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return response.status === 200
  }
}
